import tw, { styled } from 'twin.macro';

const alignText = {
  left: tw`text-left`,
  center: tw`text-center`,
};

export const Container = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`}
`;

export const Wrapper = styled.div`
  ${tw`relative`}
  ${tw`mt-5 md:mt-8 mb-6 last-of-type:mb-0`}
`;

export const Header = styled.div`
  ${tw`px-2 md:px-0`}
`;

export const Eyebrow = styled.p`
  ${tw`font-inter font-bold`}
  ${tw`text-primary-p1 text-tag-m`}
  ${tw`mb-2`}
`;

export const Headline = styled.h2`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-secondary-s1`}
  ${tw`text-mobile-heading-l lg:text-heading-l`}
`;

export const Subheadline = styled.p`
  ${tw`font-inter font-regular`}
  ${tw`text-body-l text-primary-p1`}
  ${tw`mt-2 md:mt-3`}
`;

export const Section = styled.section<{
  align: Queries.kontent_item_carousel_section_elements_align_enum;
}>`
  ${tw`overflow-hidden`}
  ${tw`bg-ui-colours-ui1`}
  ${Eyebrow}, ${Headline}, ${Subheadline} {
    ${({ align }) => alignText[align]}
  }
`;
